import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=a51abfdc&"
import script from "./search-input.vue?vue&type=script&lang=ts&"
export * from "./search-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports